import { render, staticRenderFns } from "./TemplateNavbar.vue?vue&type=template&id=ded3892e&scoped=true"
import script from "./TemplateNavbar.vue?vue&type=script&lang=js"
export * from "./TemplateNavbar.vue?vue&type=script&lang=js"
import style0 from "./TemplateNavbar.vue?vue&type=style&index=0&id=ded3892e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded3892e",
  null
  
)

export default component.exports